export default {
    atlasjet: 'اطلس جت',
    airFrance: 'ایرفرانس',
    caspian: 'کاسپین',
    iranAir: 'ایران ایر',
    lufthansa: 'لوفتهانزا',
    mahan: 'ماهان',
    qatar: 'قطر',
    turkish: 'ترکیش ایر',
};
